import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import OrderPage from "@/pages/OrderPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import OrderConfirmation from "@/pages/OrderConfirmation";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import RentalsPage from "@/pages/RentalsPage";
import RentalPackagesPage from "@/pages/RentalPackagesPage";
import GalleryPage from "@/pages/GalleryPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  // Seed data on first load
  useEffect(() => {
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        console.log("Seed data may already exist");
      }
    };
    seedData();
  }, []);

  return (
    <div className="App min-h-screen bg-background">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/rentals" element={<RentalsPage />} />
          <Route path="/rental-packages" element={<RentalPackagesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/change-password" element={<ChangePasswordPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
